<template>
  <div @click.self="open" ref="el" class="relative">
    <slot />
    <div
      v-if="isOverDropZone"
      class="absolute left-0 top fit flex flex-center text-center bg-grey text-black duration-300 font-medium"
      style="opacity: 0.9"
    >
      Drop to upload
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useFileDialog, useDropZone } from '@vueuse/core';
import { getBaseURL } from '@/config.js';

const emit = defineEmits('success');

const { files, open, reset, onChange } = useFileDialog();
onChange(async (files) => {
  // console.log(files[0]);
  await handleUpload(files[0]);
});

const el = ref();

const { isOverDropZone } = useDropZone(el, {
  onDrop,
});

async function onDrop(files) {
  // called when files are dropped on zone
  await handleUpload(files[0]);
}
async function handleUpload(file) {
  // Create a FormData object
  const formData = new FormData();
  formData.append('file', file);

  try {
    // Make a POST request to the server endpoint
    const response = await fetch(
      getBaseURL() + '/fleets/uploadFiles',
      {
        method: 'POST',
        body: formData,
      },
    );

    if (response.ok) {
      // Parse JSON response
      const data = await response.json();
      // Access the path property
      const filePath = data.path;
      let arr = filePath.split('/');
      let path = arr.at(-1);
      emit('success', path);
    } else {
      // Handle error response
      console.error('Failed to upload file:', response.statusText);
    }
  } catch (error) {
    console.error('Error uploading file:', error);
  }
}
</script>
